import {
  fetchMyOrderList,
  fetchMyOrderInfo,
  closeMyOrder,
  fetchMyOrderInfoState,
  OrderAppInstall
} from '@/api/myOrder';

const myorder = {
  state: {
  },

  mutations: {
  },

  actions: {
    // 获取我的订单数据
    GetMyOrderList({ commit }, resdata) {
      return new Promise((resolve, reject) => {
        fetchMyOrderList(resdata)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    // 获取我的订单详情数据
    GetMyOrderInfo({ commit }, resdata) {
      return new Promise((resolve, reject) => {
        fetchMyOrderInfo(resdata)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    // 获取我的订单详情数据状态
    GetMyOrderInfoState({ commit }, resdata) {
      return new Promise((resolve, reject) => {
        fetchMyOrderInfoState(resdata)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    // 关闭我的订单数据
    CloseMyOrder({ commit }, resdata) {
      return new Promise((resolve, reject) => {
        closeMyOrder(resdata)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    //订单应用交付
    OrderAppInstall({ commit }, resdata) {
      return new Promise((resolve, reject) => {
        OrderAppInstall(resdata)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
  }
};

export default myorder;



// WEBPACK FOOTER //
// ./src/store/modules/myOrder.js